<script>
  import { mapGetters } from 'vuex';

  import MiniCartItem from './MiniCartItem';

  export default {
    name: 'miniCartStore',

    components: {
      MiniCartItem,
    },

    props: {
      /**
       * The campaign label if a campaign exists
       */
      campaignLabel: {
        type: String,
        default: '',
      },
      store: {
        type: Object,
        required: true,
      },
    },

    computed: {
      ...mapGetters({
        getCompanyById: 'cart/companyById',
      }),
      storeItems() {
        let items = [];

        Object.keys(this.store).forEach((key) => {
          items = items.concat(this.store[key]);
        });

        return items;
      },
      company() {
        const companyId = this.storeItems[0].company;

        return this.getCompanyById(companyId); // returns undefined until the companies in vuex are loaded
      },

      licenseNumber() {
        return this.company.licenses?.[0]?.number || '';
      },
    },
  };
</script>

<template>
  <li :class="$style.store">
    <div class="ll-pa-2" :class="$style.header">{{ company.name }} ({{ licenseNumber }})</div>

    <transition-group class="ll-px-2" name="mini-cart-list" tag="ul">
      <MiniCartItem
        v-for="(item, index) in storeItems"
        class="mini-cart-list__item"
        :campaign-label="campaignLabel"
        :company="company"
        :item="item"
        :key="`${index}-${item.id}`"
      />
    </transition-group>
  </li>
</template>

<style lang="scss" module>
  .store {
    ul:first-child {
      border-top: none;
    }
  }

  .header {
    background: var(--color-ice-200);
    border-top: none;
    color: var(--color-ice-900);
    font-size: typo('small', 'size');
    font-weight: font-weight('medium');
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
</style>
